import { Alert, AlertIcon } from '@chakra-ui/alert';
import { Button } from '@chakra-ui/button';
import { Box, Flex } from '@chakra-ui/layout';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { useSurveyBannerModel } from '../models/SurveyBannerModel';
import { ProgressBar } from './Step';

type BannerProps = {
  setShowModal: (value: boolean) => void;
};

export const Banner: React.FC<BannerProps> = ({ setShowModal }) => {
  const model = useSurveyBannerModel();

  const existing = model.steps.join() == 'CONFIGURE_INVESTOR,ACCREDITATION';
  const stepInfo = model.getStepInfo(model.steps[model.currentStep], existing);

  return stepInfo == null ? null : (
    <Box backgroundColor="white" width={'100%'}>
      <Flex
        flex={1}
        flexDirection={['column', 'column', 'column']}
        borderBottomWidth={'1px'}
        borderBottomColor={'gray.100'}
        gap={'20px'}
        padding="20px">
        <Flex
          flexDirection={['row', 'row', 'row']}
          justifyContent="space-between"
          alignItems={['center', 'center', 'center']}
          gap={['20px', '20px', '50px']}>
          <Flex direction={'column'}>
            <TextBlock
              fontSize={['16px', '16px', '20px']}
              mr={'10px'}
              whiteSpace="nowrap"
              color={'blue.500'}
              weight="bold">{`Step ${stepInfo?.number} of 4`}</TextBlock>
            <TextBlock fontSize={['16px', '16px', '20px']} whiteSpace="nowrap" weight="bold">
              {stepInfo?.title}
            </TextBlock>
          </Flex>
          <Box display={['none', 'none', 'none', 'flex']} width="100%" justifyContent={'center'} alignItems={'center'}>
            <ProgressBar currentStep={stepInfo?.number ? stepInfo.number - 1 : 0} totalSteps={4} />
          </Box>
          <Box
            onClick={() => {
              setShowModal(true);
            }}
            mt={['10px', '0px']}>
            <Button
              padding={['10px 15px', '10px 15px', '30px 35px']}
              fontFamily={FontFamily.HELVETICA_NOW_BOLD}
              fontSize={['12px', '12px', '16px', '16px']}>
              {stepInfo?.buttonText}
            </Button>
          </Box>
        </Flex>
        {stepInfo.alert ? (
          <Box>
            <Alert
              status="info"
              style={{ border: '1px solid #8EC0FB', borderRadius: '10px', color: '#0971EC', fontWeight: 600 }}>
              <AlertIcon color="#0971EC" />
              {stepInfo.alert}
            </Alert>
          </Box>
        ) : null}
      </Flex>
    </Box>
  );
};
